import React from 'react';
import { compose, withHandlers, withProps, lifecycle, withState } from 'recompose';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import { get } from 'lodash';
import { getService, updateService } from './_api';
import withLoader from '../app/withLoader';
import { withSnackbar } from 'notistack';
import AddServiceForm from './form/addForm.js';

const styles = theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    padding: 20,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
});

const enhance = compose(
  withStyles(styles),
  withLoader,
  withSnackbar,
  withProps(({ match: { params: { id } }, addAttribute }) => ({
    serviceId: id,
  })),
  withState('item', 'setItem', null),

  withHandlers({
    loadItem: ({ serviceId, setItem }) => async () => {
      const resp = await getService(serviceId);
      if (resp) {
        setItem(resp);
      }
    },
  }),
  lifecycle({
    async componentDidMount() {
      const { serviceId, loadItem, toggleLoader } = this.props;
      toggleLoader();
      await loadItem(serviceId);
      toggleLoader(false);
    },
  }),

  withHandlers({
    onSubmit: ({ toggleLoader, enqueueSnackbar, history }) => async values => {
      toggleLoader();
      const resp = await updateService(values);
      if (get(resp, 'success', false)) {
        enqueueSnackbar('Služba byla úspěšně změněna.', { variant: 'success' });
      } else {
        enqueueSnackbar('Službu se nepovedlo upravit.', { variant: 'error' });
      }
      toggleLoader(false);
      history.push('/services');
    },
  }),
);

export default enhance(({ classes, item, onSubmit }) => (
  <div className={classes.root}>
    <h3>Upravit službu</h3>
    <Paper className={classes.paper}>
      {item && <AddServiceForm onSubmit={onSubmit} initialValues={{ ...item }} />}
    </Paper>
  </div>
));



// WEBPACK FOOTER //
// ./src/modules/services/detail.js